import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import { compose } from "redux";
import { useFirestore } from "react-redux-firebase";
import PageLoader from "../../layout/PageLoader";
import logo from "../../logo2.png";

const useStyles = makeStyles((theme) => ({
  root: {},
  form: {
    justifyContent: "center",
    textAlign: "center",
    margin: "0 auto",
    padding: 10,
  },
  loading: {
    color: theme.palette.text.primary,
    margin: 0,
  },
  pageLoaderWrapper: {
    marginTop: -350,
  },
}));

const Checkout = (props) => {
  const classes = useStyles();
  const firestore = useFirestore();

  const [showLoaderMessage, setShowLoaderMessage] = useState(false);

  useEffect(() => {}, [showLoaderMessage]);

  const showTempMessage = (e) => {
    e.preventDefault();
    alert(
      "Checkout is currently disabled. Please contact durbancomics@gmail.com to place an order."
    );
  };

  return (
    <div className={classes.root}>
      <form
        id="addOrderForm"
        className={classes.form}
        onSubmit={showTempMessage}
      >
        {!showLoaderMessage ? (
          <Button
            className={classes.proceed}
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#1CB5E0",
              color: "white",
            }}
            type="submit"
          >
            Proceed to checkout
          </Button>
        ) : null}

        {showLoaderMessage ? (
          <div className={classes.loading}>
            Validating payment. Please Wait....
            <div className={classes.pageLoaderWrapper}>
              <PageLoader />
            </div>
          </div>
        ) : null}
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    inventory: state.firebase.inventory,
    orders: state.firebase.orders,
  };
};

export default compose(connect(mapStateToProps))(Checkout);
